import Base from './Base';

class User extends Base {

    constructor () {
        super();
        this.endpoint = 'users';
    }

    updateFiscals( fiscals ) {
        return fetch(this.getUrlEndpoint("update/fiscals"),{
            method: 'PATCH',
            headers: this.headers,
            body: JSON.stringify(fiscals)
        }).then( response => response.json() )
    }

    updateEmails( ccs ) {
        return fetch(this.getUrlEndpoint("update/cc"),{
            method: 'PATCH',
            headers: this.headers,
            body: JSON.stringify(ccs)
        }).then( response => response.json() )
    }

    sendImporte( importe ) {
        return fetch(this.getUrlEndpoint("nuevo/importe"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(importe)
        }).then( response => response.json() )
    }
    
    search( word ){
        return fetch(this.getUrlEndpoint("search/"+word),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    confirmedDate( user_id ) {
        return fetch(this.getUrlEndpoint("confirmed-date/"+user_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getRelationship( user_id ) {
        return fetch(this.getUrlEndpoint("relationship/"+user_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getAdeudos( user_id ) {
        return fetch(this.getUrlEndpoint("adeudos/"+user_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getSubscription( user_id) {
        return fetch(this.getUrlEndpoint("subscription/"+user_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getUniquePaymentLink( user_id) {
        return fetch(this.getUrlEndpoint("unique-link/"+user_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }
    
    getUserByUniqueLink( uniqueLink) {
        return fetch(this.getUrlEndpoint("get-unique-link/"+uniqueLink),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }
    
}

export default User;